<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <div v-show="visible">
    <v-icon
      large
      v-show="!productionlistVisible"
      class="productiontableshowicon"
      @click="toggleProductionlist()"
    >
      mdi-table-search</v-icon>
    <div
      :class="productionlistStyle"
      v-show="productionlistVisible"
    >
      <v-icon
        class="productiontablehideicon"
        @click="toggleProductionlist()"
      >mdi-chevron-down</v-icon>
      <v-card>
        <v-card-title class="py-3">
          <div class="text-h6 text-sm-h4">
            {{ language.t('RoadProfiler.ProductionFloating.title') }}
          </div>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            v-if="productionlistVisible && !isEmpty"
            @click="exportProduction();"
          >Export
          </v-btn>
        </v-card-title>
        <v-card-text style="max-height: 400px; overflow-y: scroll;">
          <RPRProductionList ref="rprProductionListx" />
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import RPRProductionList from "./ProductionList.vue";

export default {
  components: {
    RPRProductionList,
  },
  data: () => ({
    headers: [
      {
        text: "Taak",
        align: "start",
        sortable: false,
        value: "taskDesignator",
      },
      {
        text: "Duur",
        align: "start",
        sortable: false,
        value: "duration",
      },
      {
        text: "Starttijd",
        align: "start",
        sortable: false,
        value: "start_timestamp",
      },
      {
        text: "Eindtijd",
        align: "start",
        sortable: false,
        value: "stop_timestamp",
      },
      {
        text: "Freesbreedte",
        align: "start",
        sortable: false,
        value: "machineDrum",
      },
      {
        text: "Device",
        align: "start",
        sortable: false,
        value: "device_accountId",
      },
    ],
    callback: null,
    visible: false,
    productionlistVisible: false,
    data: {},
  }),
  props: {},
  watch: {},

  methods: {
    exportProduction() {
      if (!this.data) return;
      var _this = this;
      console.log(_this.data);
      this.$axios
        .get(route("api.production.rpr.excel"), {
          params: _this.data,
          responseType: "blob",
        })
        .then((response) => {
          // TODO: check status
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          // TODO: better filename
          fileLink.setAttribute("download", `RoadProfiler Productie.xlsx`);
          document.body.appendChild(fileLink);

          fileLink.click();
        });
    },
    getProduction(devices, task, start, end, callback = null) {
      this.data = { devices: devices, task: task, startdate: start, enddate: end };
      this.visible = true;
      this.callback = callback;
      this.$refs.rprProductionListx.getProduction(devices, task, start, end, this.productionLoaded);
    },
    productionLoaded(success) {
      if (this.callback != null) this.callback(success);
      // if the production is empty hide the floating table
      if (this.$refs.rprProductionListx.isEmpty()) {
        this.productionlistVisible = false;
      } else {
        this.productionlistVisible = true;
      }
    },
    empty() {
      this.productionlistVisible = false;
      this.visible = false;
      this.$refs.rprProductionListx.empty();
    },
    toggleProductionlist() {
      this.productionlistVisible = !this.productionlistVisible;

      if (this.productionlistVisible && this.$vuetify.breakpoint.xsOnly) {
        this.$emit("changePopup", "productionlist");
      }
    },
    hideProductionlist() {
      this.productionlistVisible = false;
    },
  },
  computed: {
    productionlistStyle: function () {
      return {
        floating: this.productionlistVisible && !this.$vuetify.breakpoint.xsOnly,
        hidden: !this.productionlistVisible,
        popup: this.productionlistVisible && this.$vuetify.breakpoint.xsOnly,
      };
    },
    isEmpty: function () {
      // if (this.productionlistVisible)
      return this.$refs.rprProductionListx.isEmpty();
    },
  },
};
</script>

<style scoped>
.floating {
  z-index: 75;
  position: absolute;
  bottom: 10px;
  right: 10px;
  min-width: 800px;
}

.popup {
  z-index: 202;
  position: absolute;
  top: 0px;
  max-height: 80vh;
  width: 100vw !important;
}

.hidden {
  display: none;
}

.productiontablehideicon {
  z-index: 70;
  float: right;
  margin-top: 5px;
}

.productiontableshowicon {
  z-index: 70;
  position: absolute;
  bottom: 10px;
  right: 55px;
}
</style>
